import client from './client';

export const tariffRatesApi = {
  getTariffRates: async (search = '', countryFilter = '', activeOnly = false) => {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (countryFilter) params.append('country_from', countryFilter);
    if (activeOnly) params.append('active_only', 'true');
    
    const response = await client.get(`/api/v1/tariff-rates?${params.toString()}`);
    return response.data;
  },

  createTariffRate: async (rateData) => {
    const response = await client.post('/api/v1/tariff-rates', rateData);
    return response.data;
  },

  updateTariffRate: async (rateId, rateData) => {
    const response = await client.put(`/api/v1/tariff-rates/${rateId}`, rateData);
    return response.data;
  },

  deleteTariffRate: async (rateId) => {
    const response = await client.delete(`/api/v1/tariff-rates/${rateId}`);
    return response.data;
  },

  getMaterials: async (search = '') => {
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    const response = await client.get(`/api/v1/materials${params}`);
    return response.data;
  },

  createMaterial: async (materialData) => {
    const response = await client.post('/api/v1/materials', materialData);
    return response.data;
  },

  importTariffRates: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await client.post('/api/v1/tariff-rates/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  downloadTemplate: async () => {
    const response = await client.get('/api/v1/tariff-rates/template', {
      responseType: 'blob',
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'tariff_rates_template.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  exportTariffRates: async (activeOnly = false) => {
    const params = activeOnly ? '?active_only=true' : '';
    const response = await client.get(`/api/v1/tariff-rates/export${params}`, {
      responseType: 'blob',
    });
    
    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'tariff_rates_export.xlsx';
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  getAuditTrail: async (tariffRateId = null, importBatchId = null, limit = 100) => {
    const params = new URLSearchParams();
    if (tariffRateId) params.append('tariff_rate_id', tariffRateId);
    if (importBatchId) params.append('import_batch_id', importBatchId);
    if (limit) params.append('limit', limit);
    
    const response = await client.get(`/api/v1/tariff-rates/audit?${params.toString()}`);
    return response.data;
  },
};
